export default __webpack_public_path__ + "static/media/convenience.cd10c09b.png";